import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return async function onClick() {
    await submit({
      type: 'open_new_task_overlay',
    })
  }
}
